import React from 'react'
import { TableOfContent } from '../../../../common/components'
import { Col } from '../../../../common/lib'

const ArticleToc = ({ article, faqs, location, tokens }) => {
  return (
    <Col md={3} lg={3} className="d-none d-md-none d-lg-block">
      <TableOfContent
        data={article.modularContent}
        faqs={faqs}
        location={location}
        maxHeight="80vh"
        tokens={tokens}
      />
    </Col>
  )
}

export default ArticleToc
